export default __webpack_public_path__ + "static/media/Logo-Black.83f9021c.png";